<div class="report-container">
  <!-- PAGE HEADER -->
  <div class="page-header">
    <div>
      <h2>
        <span class="material-symbols-outlined" style="font-size: 28px;">gavel</span>
        Reported Profiles
      </h2>
      <p>Review candidate violation reports, manage account suspensions, and protect community safety</p>
    </div>
    <div style="display: flex; align-items: center; gap: 12px;">
      <div class="report-counter-pill">
        <span class="material-symbols-outlined" style="font-size: 18px;">flag</span>
        {{ reports.length }} Total Reports
      </div>
      <button class="btn-refresh" (click)="loadReports()" [disabled]="loading">
        <span class="material-symbols-outlined" [class.spin]="loading">refresh</span>
        {{ loading ? 'Refreshing...' : 'Refresh' }}
      </button>
    </div>
  </div>

  <!-- STATUS TABS BAR -->
  <div class="status-tabs-bar">
    <button class="tab-btn" [class.active]="activeTab === 'ALL'" (click)="activeTab = 'ALL'">
      <span>All Reports</span>
      <span class="tab-badge">{{ getTabCount('ALL') }}</span>
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'PENDING'" (click)="activeTab = 'PENDING'">
      <span class="status-dot dot-pending"></span>
      <span>Pending Review</span>
      <span class="tab-badge">{{ getTabCount('PENDING') }}</span>
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'REVIEWED'" (click)="activeTab = 'REVIEWED'">
      <span class="status-dot dot-reviewed"></span>
      <span>Reviewed</span>
      <span class="tab-badge">{{ getTabCount('REVIEWED') }}</span>
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'ACTION_TAKEN'" (click)="activeTab = 'ACTION_TAKEN'">
      <span class="status-dot dot-action"></span>
      <span>Suspended / Action Taken</span>
      <span class="tab-badge">{{ getTabCount('ACTION_TAKEN') }}</span>
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'DISMISSED'" (click)="activeTab = 'DISMISSED'">
      <span>Dismissed</span>
      <span class="tab-badge">{{ getTabCount('DISMISSED') }}</span>
    </button>
  </div>

  <!-- LOADING / EMPTY STATES -->
  <div *ngIf="loading" style="background: white; border-radius: 20px; padding: 60px; text-align: center; border: 1px solid #e5d5d9;">
    <span class="material-symbols-outlined spin" style="font-size: 38px; color: #B01E3E;">progress_activity</span>
    <p style="margin-top: 14px; color: #6c5d63; font-weight: 500;">Loading reported candidates...</p>
  </div>

  <div *ngIf="!loading && filteredReports.length === 0" style="background: white; border-radius: 20px; padding: 60px; text-align: center; border: 1px solid #e5d5d9;">
    <div style="width: 64px; height: 64px; border-radius: 50%; background: #e8f5e9; color: #2e7d32; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px;">
      <span class="material-symbols-outlined" style="font-size: 36px;">verified_user</span>
    </div>
    <h3 style="margin: 0 0 6px; font-size: 18px; font-weight: 700; color: #2d1b22;">No Reports Found</h3>
    <p style="color: #6c5d63; font-size: 14px; margin: 0;">There are no violation reports matching the selected filter status.</p>
  </div>

  <!-- REPORTS TABLE -->
  <div class="users-table-wrap" *ngIf="!loading && filteredReports.length > 0">
    <table class="users-table">
      <thead>
        <tr>
          <th>Reported Candidate</th>
          <th>Reported By</th>
          <th>Reason & Date</th>
          <th>Reports Count</th>
          <th>Status</th>
          <th style="text-align: right;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of filteredReports">
          <!-- REPORTED USER COLUMN -->
          <td>
            <div class="td-profile">
              <div class="profile-thumb" style="width: 46px; height: 46px; min-width: 46px; max-width: 46px; border-radius: 50%; overflow: hidden; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: #B01E3E; color: white;">
                <img *ngIf="getProfilePhoto(report.reported_id)" 
                     [src]="getProfilePhoto(report.reported_id)" 
                     style="width: 46px; height: 46px; min-width: 46px; max-width: 46px; border-radius: 50%; object-fit: cover; display: block;" 
                     alt="Reported User">
                <span *ngIf="!getProfilePhoto(report.reported_id)">{{ getInitials(report.reported_id) }}</span>
              </div>
              <div>
                <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                  <span class="user-name" (click)="openReviewModal(report)">
                    {{ report.reported_id?.basic_info?.first_name || 'Candidate' }} {{ report.reported_id?.basic_info?.last_name || '' }}
                  </span>
                  <span class="gender-badge" [ngClass]="(report.reported_id?.basic_info?.gender || '') | lowercase">
                    {{ report.reported_id?.basic_info?.gender || 'Unknown' }}
                  </span>
                  <span *ngIf="report.reported_id?.is_suspended" style="background: #dc2626; color: white; font-size: 10px; padding: 2px 6px; border-radius: 4px; font-weight: 700;">
                    SUSPENDED
                  </span>
                </div>
                <div class="user-id-tag">
                  ID: {{ report.reported_id?.basic_info?.keycloak_id || report.reported_id?._id || 'N/A' }}
                </div>
              </div>
            </div>
          </td>

          <!-- REPORTED BY COLUMN -->
          <td>
            <div style="display: flex; align-items: center; gap: 10px;">
              <div class="reporter-thumb" style="width: 32px; height: 32px; min-width: 32px; max-width: 32px; border-radius: 50%; overflow: hidden; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: #64748B; color: white;">
                <img *ngIf="getProfilePhoto(report.reporter_id)" 
                     [src]="getProfilePhoto(report.reporter_id)" 
                     style="width: 32px; height: 32px; min-width: 32px; max-width: 32px; border-radius: 50%; object-fit: cover; display: block;" 
                     alt="Reporter">
                <span *ngIf="!getProfilePhoto(report.reporter_id)">{{ getInitials(report.reporter_id) }}</span>
              </div>
              <div>
                <div style="font-weight: 600; font-size: 13px; color: #2d1b22;">
                  {{ report.reporter_id?.basic_info?.first_name || 'Anonymous' }} {{ report.reporter_id?.basic_info?.last_name || '' }}
                </div>
                <div style="font-size: 11.5px; color: #6c5d63;">
                  {{ report.reporter_id?.basic_info?.email || 'No email provided' }}
                </div>
              </div>
            </div>
          </td>

          <!-- REASON & DATE COLUMN -->
          <td>
            <div>
              <span class="reason-pill" [ngClass]="{
                'fake': (report.reason | lowercase).includes('fake'),
                'harass': (report.reason | lowercase).includes('harass') || (report.reason | lowercase).includes('abusive'),
                'wrong': (report.reason | lowercase).includes('wrong'),
                'spam': (report.reason | lowercase).includes('spam') || (report.reason | lowercase).includes('commercial'),
                'other': !(report.reason | lowercase).includes('fake') && !(report.reason | lowercase).includes('harass') && !(report.reason | lowercase).includes('wrong') && !(report.reason | lowercase).includes('spam')
              }">
                <span class="material-symbols-outlined" style="font-size: 14px;">flag</span>
                {{ report.reason || 'Other' }}
              </span>
            </div>
            <div style="font-size: 11.5px; color: #8a7a80; margin-top: 6px; display: flex; align-items: center; gap: 4px;">
              <span class="material-symbols-outlined" style="font-size: 14px;">calendar_today</span>
              Reported on {{ report.created_at | date:'mediumDate' }}
            </div>
          </td>

          <!-- REPORTS COUNT COLUMN -->
          <td>
            <div style="display: inline-flex; align-items: center; gap: 6px; background: #f3f4f6; color: #374151; font-weight: 700; font-size: 12px; padding: 4px 12px; border-radius: 12px;">
              <span class="material-symbols-outlined" style="font-size: 16px; color: #B01E3E;">report</span>
              {{ getReportCountForUser(report.reported_id?._id || report.reported_id) }} Report(s)
            </div>
          </td>

          <!-- STATUS COLUMN -->
          <td>
            <span class="status-badge" [ngClass]="(report.status || 'pending') | lowercase">
              <span class="status-dot" [ngClass]="{
                'dot-pending': (report.status || 'pending') === 'PENDING',
                'dot-reviewed': (report.status || 'pending') === 'REVIEWED',
                'dot-action': (report.status || 'pending') === 'ACTION_TAKEN'
              }"></span>
              {{ report.status === 'ACTION_TAKEN' ? 'Suspended' : (report.status || 'Pending') }}
            </span>
          </td>

          <!-- ACTIONS COLUMN -->
          <td style="text-align: right;">
            <button class="btn-review-report" (click)="openReviewModal(report)">
              <span class="material-symbols-outlined" style="font-size: 16px;">visibility</span>
              Review
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ─── LARGE CENTERED REVIEW MODAL (900-1000PX WIDE) ──────────── -->
  <div class="preview-modal-backdrop" *ngIf="selectedReport" (click)="closeReviewModal()">
    <div class="preview-modal-card" (click)="$event.stopPropagation()">
      <!-- MODAL HEADER -->
      <div class="modal-header-custom">
        <h3>
          <span class="material-symbols-outlined" style="font-size: 24px; color: #B01E3E;">shield_person</span>
          Violation Report Review
          <span style="font-size: 13px; font-weight: 600; color: #6c5d63; font-family: sans-serif;">
            — Candidate: {{ selectedReport.reported_id?.basic_info?.first_name }} {{ selectedReport.reported_id?.basic_info?.last_name }}
          </span>
        </h3>
        <button class="btn-close-modal" (click)="closeReviewModal()" title="Close Modal">
          <span class="material-symbols-outlined" style="font-size: 20px;">close</span>
        </button>
      </div>

      <!-- MODAL BODY (TWO COLUMN: LEFT = GALLERY, RIGHT = DETAILS) -->
      <div class="modal-body-custom">
        <!-- LEFT COLUMN: IMAGE VIEWER & GALLERY -->
        <div class="modal-left-column">
          <div class="image-viewer-box">
            <img *ngIf="galleryPhotos.length > 0 && galleryPhotos[currentPhotoIndex]" 
                 [src]="galleryPhotos[currentPhotoIndex]" 
                 style="max-width: 100%; max-height: 360px; object-fit: contain; border-radius: 12px; display: block;" 
                 alt="Reported Candidate Photo">
            <div class="photo-fallback" *ngIf="galleryPhotos.length === 0 || !galleryPhotos[currentPhotoIndex]">
              <div class="material-symbols-outlined">person_off</div>
              <p>No profile photos or gallery available</p>
            </div>
          </div>

          <div class="viewer-controls" *ngIf="galleryPhotos.length > 1">
            <button class="btn-viewer-nav" (click)="prevPhoto()" title="Previous Photo">
              <span class="material-symbols-outlined">arrow_back_ios_new</span>
            </button>
            <span>Photo {{ currentPhotoIndex + 1 }} of {{ galleryPhotos.length }}</span>
            <button class="btn-viewer-nav" (click)="nextPhoto()" title="Next Photo">
              <span class="material-symbols-outlined">arrow_forward_ios</span>
            </button>
          </div>
          <div *ngIf="galleryPhotos.length <= 1 && galleryPhotos.length > 0" style="color: #8a7a80; font-size: 12px; margin-top: 10px;">
            Primary Profile Photo
          </div>
        </div>

        <!-- RIGHT COLUMN: FULL PROFILE & REPORT SUMMARY -->
        <div class="modal-right-column">
          <!-- Report Reason & Description Message -->
          <div class="report-reason-box">
            <div class="reason-heading">
              <span class="material-symbols-outlined" style="font-size: 18px;">warning</span>
              Report Reason: {{ selectedReport.reason || 'General Violation' }}
            </div>
            <p class="reason-description">{{ selectedReport.description || 'No detailed message provided by reporter.' }}</p>
            <div style="font-size: 11.5px; color: #8a7a80; margin-top: 8px;">
              Reported on {{ selectedReport.created_at | date:'medium' }}
            </div>
          </div>

          <!-- Full Profile Summary -->
          <div class="section-card-block">
            <div class="section-title">
              <span class="material-symbols-outlined" style="font-size: 16px;">person</span>
              Candidate Profile Summary
            </div>
            <div class="info-grid">
              <div class="info-item">
                <span>Full Name:</span>
                <strong>{{ selectedReport.reported_id?.basic_info?.first_name || 'N/A' }} {{ selectedReport.reported_id?.basic_info?.last_name || '' }}</strong>
              </div>
              <div class="info-item">
                <span>Candidate ID:</span>
                <strong style="font-family: monospace; font-size: 11.5px;">{{ selectedReport.reported_id?.basic_info?.keycloak_id || selectedReport.reported_id?._id || 'N/A' }}</strong>
              </div>
              <div class="info-item">
                <span>Gender & Age:</span>
                <strong>{{ selectedReport.reported_id?.basic_info?.gender || 'N/A' }} / {{ selectedReport.reported_id?.basic_info?.age || 'N/A' }} yrs</strong>
              </div>
              <div class="info-item">
                <span>Marital Status:</span>
                <strong>{{ selectedReport.reported_id?.basic_info?.marital_status || 'N/A' }}</strong>
              </div>
              <div class="info-item">
                <span>Occupation:</span>
                <strong>{{ selectedReport.reported_id?.career?.occupation || 'Not Specified' }}</strong>
              </div>
              <div class="info-item">
                <span>Annual Income:</span>
                <strong>{{ selectedReport.reported_id?.career?.annual_income || 'Not Specified' }}</strong>
              </div>
              <div class="info-item">
                <span>Religion & Caste:</span>
                <strong>{{ selectedReport.reported_id?.religion?.religion || 'N/A' }} / {{ selectedReport.reported_id?.religion?.caste || 'N/A' }}</strong>
              </div>
              <div class="info-item">
                <span>Location:</span>
                <strong>{{ selectedReport.reported_id?.location?.city || selectedReport.reported_id?.basic_info?.native_city || 'N/A' }}</strong>
              </div>
            </div>
          </div>

          <!-- Reporter Details -->
          <div class="section-card-block">
            <div class="section-title">
              <span class="material-symbols-outlined" style="font-size: 16px;">record_voice_over</span>
              Reported By (Reporter Details)
            </div>
            <div class="info-grid">
              <div class="info-item">
                <span>Reporter Name:</span>
                <strong>{{ selectedReport.reporter_id?.basic_info?.first_name || 'Anonymous' }} {{ selectedReport.reporter_id?.basic_info?.last_name || '' }}</strong>
              </div>
              <div class="info-item">
                <span>Reporter Email:</span>
                <strong>{{ selectedReport.reporter_id?.basic_info?.email || 'N/A' }}</strong>
              </div>
              <div class="info-item">
                <span>Reporter Mobile:</span>
                <strong>{{ selectedReport.reporter_id?.basic_info?.mobile || 'N/A' }}</strong>
              </div>
              <div class="info-item">
                <span>Reporter ID:</span>
                <strong style="font-family: monospace; font-size: 11.5px;">{{ selectedReport.reporter_id?.basic_info?.keycloak_id || selectedReport.reporter_id?._id || 'N/A' }}</strong>
              </div>
            </div>
          </div>

          <!-- Previous Reports History -->
          <div class="section-card-block">
            <div class="section-title">
              <span class="material-symbols-outlined" style="font-size: 16px;">history</span>
              Previous Reports History ({{ previousReportsHistory.length }})
            </div>
            <div *ngIf="previousReportsHistory.length > 0" style="display: flex; flex-direction: column; gap: 8px;">
              <div *ngFor="let prev of previousReportsHistory" style="display: flex; justify-content: space-between; align-items: center; background: #ffffff; padding: 8px 12px; border-radius: 8px; border: 1px solid #e2e8f0; font-size: 12.5px;">
                <div>
                  <strong style="color: #b01e3e;">{{ prev.reason || 'Violation' }}</strong>
                  <span style="color: #64748b; margin-left: 6px;">({{ prev.created_at | date:'shortDate' }})</span>
                </div>
                <span class="status-badge" [ngClass]="(prev.status || 'pending') | lowercase" style="font-size: 10px; padding: 2px 8px;">
                  {{ prev.status || 'Pending' }}
                </span>
              </div>
            </div>
            <div *ngIf="previousReportsHistory.length === 0" style="color: #64748b; font-size: 12.5px; font-style: italic;">
              No previous violation reports found for this candidate.
            </div>
          </div>
        </div>
      </div>

      <!-- MODAL FOOTER ACTIONS -->
      <div class="modal-footer-custom">
        <div>
          <span style="font-size: 12.5px; font-weight: 600; color: #6c5d63;">
            Status: <strong [ngStyle]="{'color': selectedReport.status === 'ACTION_TAKEN' ? '#dc2626' : '#B01E3E'}">{{ selectedReport.status === 'ACTION_TAKEN' ? 'SUSPENDED' : (selectedReport.status || 'PENDING') }}</strong>
          </span>
        </div>
        <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
          <button class="btn-modal-action btn-mark-reviewed" (click)="markReviewed(selectedReport._id)">
            <span class="material-symbols-outlined" style="font-size: 16px;">task_alt</span>
            Mark as Reviewed
          </button>
          <button class="btn-modal-action btn-dismiss" (click)="dismissReport(selectedReport._id)">
            <span class="material-symbols-outlined" style="font-size: 16px;">close</span>
            Dismiss Report
          </button>
          <button class="btn-modal-action btn-suspend" *ngIf="!selectedReport.reported_id?.is_suspended" (click)="suspendUser(selectedReport._id)">
            <span class="material-symbols-outlined" style="font-size: 16px;">block</span>
            Suspend Account
          </button>
          <button class="btn-modal-action btn-ban" *ngIf="!selectedReport.reported_id?.is_suspended" (click)="banUser(selectedReport._id)">
            <span class="material-symbols-outlined" style="font-size: 16px;">gavel</span>
            Ban Account
          </button>
          <button class="btn-modal-action btn-restore" *ngIf="selectedReport.reported_id?.is_suspended" (click)="restoreUser(selectedReport._id)">
            <span class="material-symbols-outlined" style="font-size: 16px;">settings_backup_restore</span>
            Restore Account
          </button>
        </div>
      </div>
    </div>
  </div>
</div>